import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { cn } from "@/lib/utils"
import { Icon } from "@/components/ds/Icon"

/** Checkbox del Design System: 15×15, radio 4, borde 1.5px. Sin animación. */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  // Fuera del JSX a propósito: el verificador del subset de íconos
  // (`scripts/check-icon-subset.mjs`) extrae TODOS los literales de un
  // `name={...}`, así que con la comparación adentro tomaría
  // "indeterminate" por un glifo y pediría agregarlo a `index.html`.
  const indeterminado = props.checked === "indeterminate"

  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-[15px] shrink-0 rounded-[4px] border-[1.5px] border-border-strong bg-background transition-colors outline-none",
        "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        "data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground",
        "focus-visible:ring-2 focus-visible:ring-ring",
        "aria-invalid:border-destructive",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        {/*
          Guion, no check, cuando el estado es indeterminado. El fondo teal ya
          estaba diferenciado por CSS, pero el glifo era el mismo: una casilla
          "seleccioná todo" con 3 de 12 marcados se veía IGUAL que con los 12,
          o sea afirmaba algo falso justo antes de una acción masiva.

          Se lee de `props.checked` y no de un `data-state` porque
          `indeterminate` sólo existe en modo controlado — no hay forma de
          llegar a él sin pasar por esta prop.
        */}
        <Icon name={indeterminado ? "remove" : "check"} size={12} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
